<template>
	<div class="footer-safearea" />
</template>

<style lang="sass">
.footer-safearea
	padding-bottom: calc(var(--ion-safe-area-bottom) + 30px)
</style>

